import { useEffect } from 'react';

const GoogleAnalytics = () => {
  useEffect(() => {
    // Создаем и добавляем первый скрипт
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = 'https://www.googletagmanager.com/gtag/js?id=AW-17391256145';
    document.head.appendChild(script1);

    // Создаем и добавляем второй скрипт с конфигурацией
    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-17391256145');
    `;
    document.head.appendChild(script2);

    // Cleanup функция для удаления скриптов при размонтировании
    return () => {
      if (document.head.contains(script1)) {
        document.head.removeChild(script1);
      }
      if (document.head.contains(script2)) {
        document.head.removeChild(script2);
      }
    };
  }, []);

  return null; // Компонент ничего не рендерит
};

export default GoogleAnalytics;